export default __webpack_public_path__ + "static/media/TotemUso30.6ce38bf0.jpg";